const style: any = {
    'fontFamily': 'Inter',
    'fontStyle': 'normal',
    'fontWeight': '500',
    'fontSize': '12px',
    'lineHeight': '150%',
    'letterSpacing': '-0.019em',
    'color': '#676767',
}

const preformattedstyle: any = {
    'fontFamily': 'Inter',
    'fontStyle': 'normal',
    'fontWeight': '500',
    'fontSize': '12px',
    'lineHeight': '150%',
    'letterSpacing': '-0.019em',
    'color': '#676767',
    'whiteSpace': 'pre'
}

const divStyle: any = {
    'margin': '0 9%'
}

export default function HelpText() {

    return (
        <div style={divStyle}>
            <div style={style}>Tu contraseña debe contener</div>
            <div style={preformattedstyle}>  •  Longitud máxima 8 caracteres</div>
            <div style={preformattedstyle}>  •  Longitud mínima 5 caracteres</div>
            <div style={preformattedstyle}>  •  Al menos un carácter especial</div>
            <br/>
            <div style={style}>Una vez que ingreses podrás cambiar tu contraseña cuando sea necesario.</div>
        </div>
    );

}